import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseButtonSizeEnum } from '../../../../../shared/components/base-button/base-button-size.enum';
import { EpSelfEnrolmentFormService } from '../ep-self-enrolment-form-service';
import { EpSelfEnrolmentNavService } from '../ep-self-enrolment-nav.service';

@Component({
  selector: 'app-ep-self-enrolment-employer-info',
  templateUrl: './ep-self-enrolment-employer-info.component.html',
  styleUrls: ['./ep-self-enrolment-employer-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EpSelfEnrolmentEmployerInfoComponent {
  private formService = inject(EpSelfEnrolmentFormService);
  private navService = inject(EpSelfEnrolmentNavService);

  public form = this.formService.form;
  public formSubmitted = false;

  // todo - loading state

  public continue(): void {
    this.formSubmitted = true;
    const { about, headOfficeAddress, mailingAddress, logo } = this.form.controls;
    const mailingAddressValid = mailingAddress.valid || mailingAddress.controls.sameAsHeadOffice.value;
    if (about.valid && headOfficeAddress.valid && mailingAddressValid && logo.valid) {
      this.navService.goForward();
    }
  }

  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
}
